import type { ReactNode } from "react";
import {
  Frame,
  FrameDescription,
  FrameHeader,
  FramePanel,
  FrameTitle,
} from "@volca/ui/components/ui/frame";
import { cn } from "@volca/ui/lib/utils";

/** One chart: the question it answers above, the chart in a panel. */
export const ChartCard = ({
  title,
  description,
  children,
  className,
}: {
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
}) => (
  <Frame spacing="sm" className={cn("min-w-0", className)}>
    <FrameHeader>
      <FrameTitle>{title}</FrameTitle>
      {description && <FrameDescription>{description}</FrameDescription>}
    </FrameHeader>
    <FramePanel className="min-h-0">{children}</FramePanel>
  </Frame>
);
